import { Component, inject, linkedSignal, signal, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { filter } from "rxjs";
import { BsModalService } from "ngx-bootstrap/modal";
import { PageHeaderComponent } from "./features/page-header/page-header.component";
import { PageFooterComponent } from "./features/page-footer/page-footer.component";
import LogRocket from "logrocket";
import { AlertComponent } from "ngx-bootstrap/alert";
import { ClientSessionStateService } from "./services/sessionState.service";
import { AlertService } from "@company-box/services";
import { ENVIRONMENT } from "@company-box/models";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, PageHeaderComponent, PageFooterComponent, AlertComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  private title = '';
  location!: Location;
  stateSvc = inject(ClientSessionStateService);
  titleService = inject(Title);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  alertService = inject(AlertService);
  bsModalService = inject(BsModalService);
  state = this.stateSvc.getState();

  logoUrl = linkedSignal(() => {
    const referer = this.state().referer;
    try {
      if (referer) {
        const url = new URL(referer);
        return url.origin;
      }
    } catch (e) {
      return "#";
    }
    return "#";
  });

  private environment = inject(ENVIRONMENT);
  constructor() {}

  ngOnInit(): void {
    this.title = this.environment.config.title;
    this.titleService.setTitle(this.title);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      const pageTitle = route.snapshot.data["title"];
      this.titleService.setTitle(pageTitle ? `${pageTitle} | ${this.title}` : this.title);
    });

    // ngx-bootstrap's ModalContainerComponent always renders its inner .modal-dialog with a
    // hard-coded role="document" -- redundant with (and sometimes conflicting with) the
    // role="dialog" + aria-modal="true" already set correctly on the modal-container host.
    // There's no supported way to override this in the library's own config, so strip it here.
    this.bsModalService.onShown.subscribe(() => {
      document.querySelectorAll('.modal-dialog[role="document"]').forEach((el) => el.removeAttribute("role"));
    });

    if (this.environment.production) {
      if (location.protocol === "http:") {
        window.location.href = location.href.replace("http", "https");
      }
      LogRocket.init("edplti/companybox");
    }
  }
}
